/* migrated from app/script/component/accordion.js */
(() => {
  // app/script/component/accordion.js
  document.addEventListener("click", (e) => {
    const detailsOpening = document.querySelectorAll("details[open]");
    if (!detailsOpening.length || e.target.closest("details")) return;
    detailsOpening.forEach((item) => {
      if (item.closest("lazy-script, accordion-component, .section-announcement-bar")) return;
      item.open = false;
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
    if (!window.customElements.get("accordion-component")) {
      console.log("accordion-component");
      window.customElements.define("accordion-component", class accordionComponent extends HTMLElement {
        constructor() {
          super();
          if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
            const debounce = (fn, ms) => {
              let timer;
              return function(...args) {
                clearTimeout(timer);
                timer = setTimeout(() => fn.apply(this, args), ms);
              };
            };
            const debounceTime = typeof theme !== "undefined" && theme.debounceTime ? theme.debounceTime : debounce;
            this.debounce = debounceTime(this.changeState.bind(this), 300);
            window.addEventListener("resize", this.debounce);
          }
          this.querySelectorAll("summary a").forEach((link) => {
            link.addEventListener("click", (e) => {
              e.stopPropagation();
            });
          });
          this.changeState();
          setTimeout(() => {
            if (this.querySelector("details")) this.init();
          }, 0);
        }
        connectedCallback() {
          this.observeClassChanges();
        }
        disconnectedCallback() {
          if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
            window.removeEventListener("resize", this.debounce);
          }
          this.attributeObserver?.disconnect();
        }
        observeClassChanges() {
          const toggleEls = document.querySelectorAll(".jsToggleClass");
          const hasTrigger = [...toggleEls].find((el) => {
            const target = el.dataset.target;
            if (!target || !target.includes(".")) return false;
            const elmsInDOM = document.querySelectorAll(target);
            return [...elmsInDOM].some((elm) => elm === this);
          });
          if (!hasTrigger) return;
          this.attributeObserver = new MutationObserver(() => {
            const details = this.querySelector("details");
            if (!details) return;
            details.querySelector("summary")?.click();
          });
          this.attributeObserver.observe(this, { attributes: true, attributeFilter: ["class"] });
        }
        init() {
          this.details = this.querySelector("details");
          if (!this.details) return;
          this.summary = this.details.querySelector(":scope > summary");
          this.content = this.details.querySelector(":scope > *:not(summary)");
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          if (this.summary) {
            this.summary.addEventListener("click", (e) => this.onClick(e));
          }
          this.details.classList.add("accordion-initialized");
        }
        onClick(e) {
          e.preventDefault();
          this.details.style.overflow = "hidden";
          this.onCloseAccordionDifferent();
          if (this.isClosing || !this.details.open) {
            this.open();
          } else if (this.isExpanding || this.details.open) {
            this.shrink();
          }
        }
        shrink() {
          this.isClosing = true;
          const summaryPosition = window.getComputedStyle(this.summary).position;
          const startHeight = `${this.details.offsetHeight}px`;
          const styles = window.getComputedStyle(this.details);
          const paddingTop = styles.getPropertyValue("padding-top");
          const paddingBottom = styles.getPropertyValue("padding-bottom");
          const paddingTopValue = parseFloat(paddingTop) || 0;
          const paddingBottomValue = parseFloat(paddingBottom) || 0;
          const endHeight = `${summaryPosition === "absolute" ? 0 : this.summary.offsetHeight + paddingTopValue + paddingBottomValue}px`;
          if (this.animation) {
            this.animation.cancel();
          }
          this.details.classList.add("is-closing");
          this.animation = this.details.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 400,
            easing: "ease-out"
          });
          this.animation.onfinish = () => this.onAnimationFinish(false);
          this.animation.oncancel = () => this.isClosing = false;
        }
        open() {
          this.details.style.height = `${this.details.offsetHeight}px`;
          this.details.open = true;
          this.details.classList.add("is-opening");
          window.requestAnimationFrame(() => this.expand());
        }
        expand() {
          this.isExpanding = true;
          const summaryPosition = window.getComputedStyle(this.summary).position;
          const startHeight = `${this.details.offsetHeight}px`;
          const endHeight = `${summaryPosition === "absolute" && this.content ? this.content.offsetHeight : this.details.scrollHeight}px`;
          if (this.animation) {
            this.animation.cancel();
          }
          this.animation = this.details.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 400,
            easing: "ease-out"
          });
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => this.isExpanding = false;
        }
        onAnimationFinish(open) {
          this.details.open = open;
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.details.classList.remove("is-closing", "is-opening");
          this.details.style.height = "";
          this.details.style.overflow = "";
        }
        changeState() {
          if (this.hasAttribute("data-open-screen")) {
            if (window.matchMedia(this.getAttribute("data-open-screen")).matches) {
              this.querySelector("details").open = true;
            }
          }
          if (this.hasAttribute("data-close-screen")) {
            if (window.matchMedia(this.getAttribute("data-close-screen")).matches) {
              this.querySelector("details").open = false;
            }
          }
        }
        onCloseAccordionDifferent() {
          const group = this.closest(".group-accordion");
          if (!group) return;
          group.querySelectorAll("accordion-component details[open]").forEach((details) => {
            if (details !== this.details) {
              const accordion = details.closest("accordion-component");
              if (accordion && typeof accordion.shrink === "function") {
                accordion.shrink();
              }
            }
          });
        }
      });
    }
  });
})();
